import { Injectable } from '@angular/core';
import { filter, Observable, switchMap, take, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { environment } from '@environments/environment';
import { ResponseObjectSuccess } from '@interfaces/response-success';
import { AuthenticationState } from '@store/reducers/authentication.reducer';
import { selectCredential } from '@store/selectors/authentication.selectors';
import { Credential, Notificacion } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  credential$: Observable<Credential | null>;

  constructor(
    private http: HttpClient,
    private store: Store<AuthenticationState>,
  ) {
    this.credential$ = this.store.select(selectCredential);
  }

  sync(): Observable<ResponseObjectSuccess<Notificacion>> {
    return this.credential$.pipe(
      filter((credential) => credential !== null),
      switchMap((credential) => {
        if (!credential?.granted)
          return throwError(() => new Error('No credential granted'));
        
        const token =
          credential && credential?.token
            ? credential.token
            : credential?.apiKey
              ? credential?.apiKey
              : '';

        return this.http.post<ResponseObjectSuccess<Notificacion>>(
          `${environment.microEnterprise}/api/v1/sync-list`,
          { listIds: [] },
          { headers: { Authorization: token } }
        );
      }),
      take(1),
    );
  }
}
